/**
 * Facture print uses the OS print dialog (US-CHECKOUT-06).
 * Never writes terminal setup or thermal bindings.
 */
export function requestSystemInvoicePrint(
  printFn: () => void = () => {
    if (typeof window !== 'undefined' && typeof window.print === 'function') {
      window.print();
    }
  },
): void {
  printFn();
}
